import { useEffect, useState } from "react";
import { api } from "../lib/api";

export const useShops = () => {
  const [shops, setShops] = useState(null);
  useEffect(() => {
    api.get("/shops").then((r) => setShops(Array.isArray(r.data) ? r.data : [])).catch(() => setShops([]));
  }, []);
  return shops;
};
